import { Lock, LockOpen } from "lucide-react";
import { object } from "prop-types";
import "./LockIconBadge.scss";

const LockIconBadge = ({ offset = { right: -16 } }) => {
  const offsetStyles = Object.keys(offset).length
    ? Object.entries(offset).reduce((acc, [key, value]) => {
        acc[key] = typeof value === "string" ? value : `${value}px`;
        return acc;
      }, {})
    : {};

  return (
    <div className="lock-icon-badge" style={offsetStyles} aria-hidden="true">
      <Lock
        size={13}
        strokeWidth={2.3}
        className="lock-icon-badge__icon lock-icon-badge__icon--closed"
      />
      <LockOpen
        size={16}
        strokeWidth={2.3}
        className="lock-icon-badge__icon lock-icon-badge__icon--open"
      />
    </div>
  );
};

LockIconBadge.propTypes = {
  offset: object,
};

LockIconBadge.defaultProps = {
  offset: { right: -16 },
};

export default LockIconBadge;
